module.exports = __webpack_public_path__ + "static/media/boolean_operator_and_not.ffa7d568.svg";